import { createFileRoute } from "@tanstack/react-router";

import PreferredDesignersPage from "@/features/profile/preferred-designers";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/profile/designer-preference",
)({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("My Designers");

  return <PreferredDesignersPage />;
}
